export function getAttribute(attribute: string | undefined): string | boolean | null {
  if (attribute === '') {
    return true;
  } else if (attribute === undefined) {
    return null;
  } else {
    return attribute;
  }
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}

/**
 * Lazily import a dynamic chunk when the target element scrolls near the
 * viewport. Falls back to immediate import if `IntersectionObserver` is
 * unavailable.
 *
 * @param selector   CSS selector for the element that triggers the import.
 * @param factory    A function returning the dynamic `import()` promise.
 * @param rootMargin How far before the element enters the viewport the import
 *                   fires. Defaults to `'300px'`.
 */
export function observeAndImport(
  selector: string,
  factory: () => Promise<unknown>,
  rootMargin: string = '300px'
): void {
  const el = document.querySelector(selector);
  if (!el) return;

  if (!('IntersectionObserver' in globalThis)) {
    factory();
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          observer.disconnect();
          factory();
          return;
        }
      }
    },
    { rootMargin }
  );

  observer.observe(el);
}
